import React from 'react';
import styled from 'styled-components';

export const Spacer = ({ w = 0, h = 0 }) => {
  return <View w={w} h={h} />;
};

const View = styled.div`
  ${(props) => (props.w ? `width: ${props.w}px` : '')}
  ${(props) => (props.h ? `height: ${props.h}px` : '')}
`;
